import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import './help_styles/helparticles.css';

export default function HelpArticles() {
  return (
    <>
     <Container className='mt-5 mb-5 help_article'>
        <Row>
            <Col className='d-flex flex-column align-items-center art_hd'>
              <h2>PROMOTED ARTICLES</h2>
              <p>Ask anything about blockchain, Web3 and cryptocurrency</p>
            </Col>
        </Row>
        <Row className='m-auto justify-content-between'>
          <Col lg={3} md={6} className='mt-3 help_article_col'>
            <p>The recently popular internet AI: ChatGPT has actually written:
              "The Plan to Destroy Humanity"
            </p>
            <a href="">SIGNUP</a>
          </Col>
          <Col lg={3} md={6} className='mt-3 help_article_col'>
            <p>The recently popular internet AI: ChatGPT has actually written:
              "The Plan to Destroy Humanity"
            </p>
            <a href="">SIGNUP</a>
          </Col>
          <Col lg={3} md={6} className='mt-3 help_article_col'>
            <p>The recently popular internet AI: ChatGPT has actually written:
              "The Plan to Destroy Humanity"
            </p>
            <a href="">SIGNUP</a>
          </Col>
          <Col lg={3} md={6} className='mt-3 help_article_col'>
            <p>The recently popular internet AI: ChatGPT has actually written:
              "The Plan to Destroy Humanity"
            </p>
            <a href="">SIGNUP</a>
          </Col>
        </Row>
        <Row className='m-auto justify-content-between'>
          <Col lg={3} md={6} className='mt-3 help_article_col'>
            <p>The recently popular internet AI: ChatGPT has actually written:
              "The Plan to Destroy Humanity"
            </p>
            <a href="">SIGNUP</a>
          </Col>
          <Col lg={3} md={6} className='mt-3 help_article_col'>
            <p>The recently popular internet AI: ChatGPT has actually written:
              "The Plan to Destroy Humanity"
            </p>
            <a href="">SIGNUP</a>
          </Col>
          <Col lg={3} md={6} className='mt-3 help_article_col'>
            <p>The recently popular internet AI: ChatGPT has actually written:
              "The Plan to Destroy Humanity"
            </p>
            <a href="">SIGNUP</a>
          </Col>
          <Col lg={3} md={6} className='mt-3 help_article_col'>
            <p>The recently popular internet AI: ChatGPT has actually written:
              "The Plan to Destroy Humanity"
            </p>
            <a href="">SIGNUP</a>
          </Col>
        </Row>
        <Row className='m-auto justify-content-between'>
          <Col lg={3} md={6} className='mt-3 help_article_col'>
            <p>The recently popular internet AI: ChatGPT has actually written:
              "The Plan to Destroy Humanity"
            </p>
            <a href="">SIGNUP</a>
          </Col>
          <Col lg={3} md={6} className='mt-3 help_article_col'>
            <p>The recently popular internet AI: ChatGPT has actually written:
              "The Plan to Destroy Humanity"
            </p>
            <a href="">SIGNUP</a>
          </Col>
          <Col lg={3} md={6} className='mt-3 help_article_col'>
            <p>The recently popular internet AI: ChatGPT has actually written:
              "The Plan to Destroy Humanity"
            </p>
            <a href="">SIGNUP</a>
          </Col>
          <Col lg={3} md={6} className='mt-3 help_article_col'>
            <p>The recently popular internet AI: ChatGPT has actually written:
              "The Plan to Destroy Humanity"
            </p>
            <a href="">SIGNUP</a>
          </Col>
        </Row>
     </Container>
    </>
  )
}
